<div class="old-map-container">
    <div id="map" class="old-map-container-map"></div>
    <ng-container *ngIf="iconDisplay">
        <div @fadeInOut class="overlay" *ngFor="let item of overlayPositions; index as i"
              [ngStyle]="{ top: item.top + 'px', left: item.left + 'px', height: item.height + 'px', width: item.width + 'px' }">
            <app-icon [icon]="item.icon" [invert]="1" [width]="item.width * 0.55" [height]="item.height * 0.55" />
        </div>
    </ng-container>
</div>

<div id="cluster" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/bomb.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="panorama" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/panorama.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="bomb" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/bomb.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="star" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/star.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="target" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/target.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="medal" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/medal.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="train" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/train.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="fist" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/fist.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="attention" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/attention.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="evacuation" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/evacuation.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="crane" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/crane.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="gear" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/gear.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="helmet" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/helmet.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>
<div id="ashoka" style="display:none;">
    <div style="width: 40px; height: 40px; background-color: #D44236; border-radius: 50%; position: relative;">
        <img src="app/assets/icons/ashoka.svg" style="width: 20px; height: 20px; position: absolute; top: 10px; left: 10px; filter: invert(1)" alt="icon"/>
    </div>
</div>